import React from 'react';

class SubmitButton extends React.Component {
  render() {
    let body = (
      <button className={this.props.className} onClick={this.props.onClick}>
        {this.props.text}
      </button>
    );

    if (this.props.submitting) {
      body = (
        <button className={this.props.className}>
          {this.props.submittingText}
          <span className="ellipsis-loader" />
        </button>
      );
    }

    return (
      <div className="submit-group">
        <div className="btn-wrapper">{body}</div>
      </div>
    );
  }
}

export { SubmitButton };
